import {NgModule} from '@angular/core';
import {TrimPipe} from './trim.pipe';

@NgModule({
  exports: [
    TrimPipe
  ],
  declarations: [
    TrimPipe
  ]
})
export class PipeModule {}
